import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Register from '@/components/Register'
import Forget from '@/components/Forget'
import ChangePassword from '@/components/ChangePassword'

import Layout from '@/components/Layout'
import Index from '@/components/Index'
// import Header from '@/components/Header'
// import Footer from '@/components/Footer'
import News from '@/components/News'
import Us from '@/components/Us'
import MarketInfo from '@/components/MarketInfo'
import Manager from '@/components/Manager'
import Systematic from '@/components/Systematic'
import Buy from '@/views/sys/buy'
import Buy_d from '@/views/sys/buy_d'
import Buy_g from '@/views/sys/buy_g'
import Buy_info from '@/views/sys/buy_info'
import Buy_success from '@/views/sys/buy_success'

import MyLeft from '@/components/MyLeft'//个人中心左侧
import Personal from '@/views/my/Personal'
import System from '@/views/my/System'
import Collect from '@/views/my/Collect'
import Ccjf from '@/views/my/Ccjf'
import Exchange from '@/views/my/Exchange'

import NewsDetail from '@/views/news/NewsDetail'

import videoDetail from '@/views/manager/videoDetail'

// import Saas from '@/components/Saas'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  // base: '/',
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Index',
          component: Index,
          meta:{
            title: '蛋鸡管家-首页'
          }
        },
        {
          path: 'Login',
          name: 'Login',
          component: Login,
          meta:{
            title: '蛋鸡管家-登录'
          }
        },
        {
          path: 'Register',
          name: 'Register',
          component: Register,
          meta:{
            title: '蛋鸡管家-注册'
          }
        },
        {
          path: 'Forget',
          name: 'Forget',
          component: Forget,
          meta:{
            title: '蛋鸡管家-忘记密码'
          }
        },
        {
          path: 'ChangePassword/:pas',
          name: 'ChangePassword',
          component: ChangePassword,
          meta:{
            title: '蛋鸡管家-修改密码'
          }
        },
        {
          path: 'News/:nav',
          name: 'News',
          component: News,
          meta:{
            title: '蛋鸡管家-新闻资讯'
          }
        },
        {
          path: 'NewsDetail/:id',
          name: 'NewsDetail',
          component: NewsDetail,
          meta:{
            title: '蛋鸡管家-新闻详情'
          }
        },
        {
          path: 'Us',
          name: 'Us',
          component: Us,
          meta:{
            title: '蛋鸡管家-关于我们'
          }
        },
        {
          path: 'Systematic',
          name: 'Systematic',
          component: Systematic,
          meta:{
            title: '蛋鸡管家-应用市场'
          }
        },
        {
          path: 'Buy',
          name: 'Buy',
          component: Buy,
          meta:{
            title: '系统购买-蛋鸡集团版'
          }
        },
        {
          path: 'Buy_d',
          name: 'Buy_d',
          component: Buy_d,
          meta:{
            title: '系统购买-蛋鸡供应链SAAS系统'
          }
        },
        {
          path: 'Buy_g',
          name: 'Buy_g',
          component: Buy_g,
          meta:{
            title: '系统购买-商品代养殖管理'
          }
        },
        {
          path: 'Buy_info/:id',
          name: 'Buy_info',
          component: Buy_info,
          meta:{
            title: '系统购买-确认信息'
          }
        },
        {
          path: 'Buy_success',
          name: 'Buy_success',
          component: Buy_success,
          meta:{
            title: '系统购买-购买成功'
          }
        },
        {
          path: 'MarketInfo',
          name: 'MarketInfo',
          component: MarketInfo,
          meta:{
            title: '蛋鸡管家-行情报价'
          }
        },
        {
          path: 'Manager',
          name: 'Manager',
          component: Manager,
          meta:{
            title: '蛋鸡管家-金鸡讲堂'
          }
        },
        {
          path: 'videoDetail/:id',
          name: 'videoDetail',
          component: videoDetail,
          meta:{
            title: '蛋鸡管家-视频详情'
          }
        },
        {
          path: '/p/',
          component: MyLeft,
          children: [
            {
              path: 'Personal',
              name: 'Personal',
              component: Personal,
              meta:{
                title: '蛋鸡管家-个人中心'
              }
            },
            {
              path: 'System',
              name: 'System',
              component: System,
              meta:{
                title: '蛋鸡管家-操作系统'
              }
            },
            {
              path: 'Collect',
              name: 'Collect',
              component: Collect,
              meta:{
                title: '蛋鸡管家-我的收藏'
              }
            },
            {
              path: 'Ccjf',
              name: 'Ccjf',
              component: Ccjf,
              meta:{
                title: '蛋鸡管家-积分查询'
              }
            },
            {
              path: 'Exchange',
              name: 'Exchange',
              component: Exchange,
              meta:{
                title: '蛋鸡管家-积分兑换'
              }
            }
          ]
        }
      ]
    }
    // {
    //   path: '/oauth',
    //   name: 'oauth',
    //   component: Saas,
    //   meta:{
    //     title: '蛋鸡管家-登录'
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js